import { useLocation, useNavigate } from "react-router-dom/dist";
import NiceModal from "@ebay/nice-modal-react";
import { Container } from "@mui/material";
import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat, userNameFormat } from "InitialData/regExp";
import Dummy from "components/Dummy";
import P from "components/P";
import BackButton from "components/buttons/BackButton";
import CustomButton from "components/buttons/CustomButton";
import EmailDomainSelector from "components/inputs/email/EmailDomainSelector";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { isAdult, validateInputs } from "shared/utils/Utils";
import { bffRequester } from "App";
import { PropaneSharp } from "@mui/icons-material";

function TestPageResult(props) {
    const location = useLocation();
    const [confirm, setConfirm] = useState();
    const [value, setValue] = useState();
    const navigate = useNavigate();


    const inputs = useRef([]);
    const [duplicateCheck, setDuplicateCheck] = useState(true);
    const [mobileNumber, setMobileNumber] = useState("");
    const [userName, setUserName] = useState();
    const [password, setPassword] = useState();
    const [networkOperator, setNetworkOperator] = useState();
    const [authMethod, setAuthMethod] = useState();
    const [gender, setGender] = useState();
    const [nation, setNation] = useState();
    const [ci, setCi] = useState();
    const [di, setDi] = useState();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "50px",
        width: "100px"
    }
    const onDuplicateClick = () => {
        
        let data = { userName: "", storeId: "root", role: "MEMBER" }
        data.userName = inputs.current[0].getValue();
        // 먼저 형식 유효성 검사를 수행합니다.
        const isFormatValid = userNameFormat.exp.test(data.userName);
        if (!isFormatValid) {
            toast.error("올바른 아이디를 입력해주세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
            return;
        }
        
        requester.userDuplicateCheck(data, (result) => {
        
            if (result.data) {
                toast.error("이미 사용중인 아이디입니다", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });

                inputs.current[0].focus();
                setDuplicateCheck(result.data);
            } else {
                toast.success(t("available"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
                setDuplicateCheck(result.data);
            }
        });
    }

    const signUp = () => {

        let data = { storeId: "root", userName: "", password: "", mobileNumber: mobileNumber, email: "", ci: "", di: "" }
        let addressData = { address: "", addressDetail: "", zipcode: "" }

        if (!duplicateCheck) {
            validateInputs(inputs.current).then((isValid) => {
                if (isValid) {
                    // 유효성 검사를 통과하면, 입력 필드로부터 값을 가져와 data 객체를 업데이트
                    data.userName = inputs.current[0].getValue();
                    data.password = inputs.current[1].getValue();
                    // data.mobileNumber = userPhoneNum
                    data.ci = ci;
                    data.di = di;
                        // data.mobileNumber = inputs.current[2].getValue();
                        // data.email = inputs.current[3].getValue() + '@' + inputs.current[4].getSelectedDomain();
                        // addressData.address = inputs.current[5].getValue();
                        // addressData.addressDetail = inputs.current[6].getValue();
                        // addressData.zipcode = inputs.current[7].getValue();

                        dispatch(HistoryReducer.actions.setLoading(true));
                    requester.memberSignUp(data, (result) => {
                        if (result.code === 0) {
                            navigate("/signUp/complete", {state: {storeCode: location.state.storeCode }})
                            // let row = { type: "Register", data:  data.userName}
                            // techtonicChainRequester.userBalance(row, (result) => {
                            //     
                            // })
                        } else {
                            toast.error(t("문제가 발생했습니다 관리자에게 문의하세요"), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                        dispatch(HistoryReducer.actions.setLoading(false));
                    });

                    // 이후 데이터 처리 로직...
                } else {
                    toast.error(t("pleaseCheck"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });

                }
            })

        } else {
            toast.error(t("duplicateCheck"), {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
        }

    }

    useEffect(() => {
        if (location) {

            const outerMOKConfirmData = location.state.data.MOKConfirmData;
            const innerMOKConfirmData = JSON.parse(outerMOKConfirmData);
            if (innerMOKConfirmData.resultCode === "2000") {

                setConfirm(location.state.data);
                setConfirm(
                    {
                        MOKConfirmData: innerMOKConfirmData,
                        session: location.state.token.session,
                        authNumber: location.state.authNumber ? location.state.authNumber : '',
                        type: location.state.type,
                        info: location.state.info
                    }
                );

            } else {
                alert("입력한 정보가 올바르지 않습니다. 처음부터 다시시도해주세요")
            }


        }
    }, [location])
    useEffect(() => {
        
        let adultYn = "";
        if (confirm) {
            
            if (confirm.type === "PASS") {
                bffRequester.apiResult(confirm, (result) => {
                    adultYn = isAdult(result.resultData.userBirthday);
                    if(adultYn){
                        setCi(result.resultData.ci);
                    setDi(result.resultData.di);
                    setMobileNumber(result.resultData.userPhone);
                    
                    }else{
                        alert("성인만 가입할 수 있습니다.");
                        navigate("/signUp", {replace: true})
                    }
                    
                })
            } else if (confirm.type === "SMS") {
                adultYn = isAdult(confirm.info.userBirthday);
                if(adultYn){
                    
                    setMobileNumber(confirm.info.userPhoneNum);
                }else{
                    alert("성인만 가입할 수 있습니다.");
                        navigate("/signUp", {replace: true})
                }
                
            }


        }
    }, [confirm])


    return (
        <VerticalFlex gap={20}>
            <FlexChild width={"100%"}>
                <VerticalFlex>
                    <FlexChild padding={"10px 0"}>
                        <HorizontalFlex>
                            <FlexChild width={30}>
                                <BackButton />
                            </FlexChild>
                            <FlexChild>
                                <Center>
                                    <P size={20} color={"black"}>회원가입</P>
                                </Center>
                                <Dummy width={"30px"} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D0D0D0"} />
                </VerticalFlex>
            </FlexChild>
            <FlexChild width={"90%"}>
                <VerticalFlex gap={10}>
                    <FlexChild>
                        <Center width={"100%"} textAlign={"left"}>
                            <P>아이디</P>
                        </Center>
                    </FlexChild>

                    <FlexChild>
                        <HorizontalFlex gap={20}>
                            <FlexChild>
                                <InputText mobileText gray ref={el => (inputs.current[0] = el)} placeHolder={"아이디"} regExp={[textFormat]} />
                            </FlexChild>
                            <FlexChild width={"max-content"}>
                                <CustomButton style={btnStyle} text={"중복확인"} onClick={onDuplicateClick} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                </VerticalFlex>

            </FlexChild>
            <FlexChild width={"90%"}>
                <VerticalFlex gap={10}>
                    <FlexChild>
                        <Center width={"100%"} textAlign={"left"}>
                            <P>비밀번호</P>
                        </Center>
                    </FlexChild>
                    <FlexChild>
                        <InputPassword guide ref={el => (inputs.current[1] = el)} mobileSignUp placeHolder={"비밀번호(대문자, 소문자,숫자,특수문자 포함)"} placeHolderComfirm={t("password") + t("confirm")} confirmVisible={true} regExp={[passwordFormat]} />
                        
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
            <FlexChild width={"90%"}>
                <CustomButton text={"회원가입"} style={btnStyle} onClick={signUp} />
            </FlexChild>
        </VerticalFlex>
    );


}

export default TestPageResult;